exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2TLmOHdqVNcfjmawd6ZftV{color:#f70 !important}\n", ""]);

// Exports
exports.locals = {
	"activeButton": "_2TLmOHdqVNcfjmawd6ZftV"
};